import { useEffect, useState } from 'react'
import { CheckCircle2, Clock, XCircle, X } from 'lucide-react'
import { billingService } from '@core/billing'

/**
 * Payment-return banner (Epic H, Phase 1). Shown when Stripe redirects back to
 * Atlas with ?payment=success|cancel. On success it reads the real payment
 * status (card = paid immediately, Multibanco = pending until the async
 * webhook). Self-gates on the query param; dismiss strips it from the URL.
 */
export function PaymentBanner() {
  const params = new URLSearchParams(window.location.search)
  const payment = params.get('payment')
  const orderId = params.get('order')
  const [status, setStatus] = useState<string | null>(null)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (payment === 'success' && orderId) {
      billingService.getOrderPayment(orderId).then(({ payment: p }) => {
        if (p) setStatus(p.payment_status)
      })
    }
  }, [payment, orderId])

  if (!payment || dismissed) return null

  const dismiss = () => {
    setDismissed(true)
    const url = new URL(window.location.href)
    url.searchParams.delete('payment')
    window.history.replaceState({}, '', url.toString())
  }

  let tone = 'border-clay/30 bg-schist/95 text-limestone'
  let Icon = Clock
  let msg = 'A confirmar pagamento...'

  if (payment === 'cancel') {
    tone = 'border-amber-300/30 bg-amber-500/10 text-amber-200'
    Icon = XCircle
    msg = 'Pagamento cancelado. Pode tentar novamente a partir do pedido.'
  } else if (status === 'paid') {
    tone = 'border-green-300/30 bg-green-500/10 text-green-200'
    Icon = CheckCircle2
    msg = 'Pagamento confirmado. O seu pedido esta a ser processado.'
  } else if (status === 'pending') {
    tone = 'border-sky-300/30 bg-sky-500/10 text-sky-200'
    Icon = Clock
    msg = 'Pagamento em processamento (Multibanco). O pedido inicia apos a confirmacao.'
  } else if (status === 'failed') {
    tone = 'border-red-300/30 bg-red-500/10 text-red-200'
    Icon = XCircle
    msg = 'O pagamento nao foi concluido. Pode tentar novamente.'
  }

  return (
    <div className="absolute top-16 left-1/2 -translate-x-1/2 z-30 px-4 w-full max-w-md pointer-events-none">
      <div className={`pointer-events-auto flex items-center gap-3 rounded-lg border px-4 py-3 shadow-lg shadow-black/20 ${tone}`}>
        <Icon size={20} className="shrink-0" />
        <span className="text-sm flex-1">{msg}</span>
        <button type="button" onClick={dismiss} className="opacity-70 hover:opacity-100" aria-label="Fechar">
          <X size={16} />
        </button>
      </div>
    </div>
  )
}
